import { sportFlagsToKeys, sportKeysToFlags, sportsEnum } from '../enums';

/**
 * Преобразует числовые флаги видов спорта в массив строковых ключей
 * @param {number|Array<number>} sportFlags - Числовые флаги видов спорта
 * @returns {Array<string>} Массив строковых ключей видов спорта
 */
export const sportFlagsToKeysArray = (sportFlags) => {
  if (!sportFlags) return [];
  
  const flags = Array.isArray(sportFlags) ? sportFlags : [sportFlags];
  const result = [];
  
  flags.forEach(flag => {
    if (sportFlagsToKeys[flag]) {
      result.push(sportFlagsToKeys[flag]);
    }
  });
  
  return result;
};

/**
 * Преобразует массив строковых ключей в числовые флаги
 * @param {Array<string>} sportKeys - Массив строковых ключей видов спорта
 * @returns {Array<number>} Массив числовых флагов
 */
export const sportKeysToFlagsArray = (sportKeys) => {
  if (!sportKeys || !Array.isArray(sportKeys)) return [];
  
  return sportKeys.map(key => sportKeysToFlags[key]).filter(flag => flag !== undefined);
};

/**
 * Получает названия видов спорта по числовым флагам
 * @param {number|Array<number>} sportFlags - Числовые флаги видов спорта
 * @returns {Array<string>} Массив названий видов спорта
 */
export const getSportNames = (sportFlags) => {
  const keys = sportFlagsToKeysArray(sportFlags);
  return keys.map(key => sportsEnum[key]).filter(name => name);
};

/**
 * Проверяет, содержит ли флаг определенный вид спорта
 * @param {number} flag - Числовой флаг
 * @param {string} sportKey - Строковый ключ вида спорта
 * @returns {boolean} true, если флаг содержит указанный вид спорта
 */
export const hasSport = (flag, sportKey) => {
  const sportFlag = sportKeysToFlags[sportKey];
  return sportFlag && (flag & sportFlag) === sportFlag;
};

/**
 * Добавляет вид спорта к флагу
 * @param {number} flag - Исходный флаг
 * @param {string} sportKey - Строковый ключ вида спорта
 * @returns {number} Новый флаг с добавленным видом спорта
 */
export const addSport = (flag, sportKey) => {
  const sportFlag = sportKeysToFlags[sportKey];
  return sportFlag ? (flag | sportFlag) : flag;
};

/**
 * Удаляет вид спорта из флага
 * @param {number} flag - Исходный флаг
 * @param {string} sportKey - Строковый ключ вида спорта
 * @returns {number} Новый флаг без указанного вида спорта
 */
export const removeSport = (flag, sportKey) => {
  const sportFlag = sportKeysToFlags[sportKey];
  return sportFlag ? (flag & ~sportFlag) : flag;
};
